import ModalPresenter from './ModalPresenter';

class CartPresenter {
  constructor() {
    this.modalPresenter = new ModalPresenter();
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    const modal = document.querySelector('.bms-custom-modal');
    const trigger = document.querySelector('[data-bms-hotspot]');
    if (!modal || !trigger) return;

    const app = trigger.dataset.bmsHotspot;
    if (!app) return;

    const closeButton = modal.querySelector('.close-button');
    if (!closeButton) return;

    function toggleModal() {
      if (modal.classList.contains('show-modal')) {
        const event = new CustomEvent('modalClosed', {
          detail: {
            modalClosed: true,
          },
        });
        document.dispatchEvent(event);
      }
      modal.classList.toggle('show-modal');
    }

    function windowOnClick(event) {
      if (event.target === modal) {
        toggleModal();
      }
    }

    trigger.addEventListener('click', () => {
      this.modalPresenter.init(app);
    });
    trigger.addEventListener('click', toggleModal);
    closeButton.addEventListener('click', toggleModal);
    window.addEventListener('click', windowOnClick);
  }
}

export default new CartPresenter();
